import { defineMessage } from 'services/localization';

export const messages = {
    grnDescription: defineMessage('has_changed_the_goods_received_status_to_status'),
    grnNotReceived: defineMessage('not_received'),
    grnPartiallyReceived: defineMessage('partially_received'),
    grnFullyReceived: defineMessage('fully_received'),
    onBehalfOfDisplayName: defineMessage('author_on_behalf_of_onbehalfof'),
};
